
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, create } from "store/group-user";
import { AppMessage } from "components";

interface ApiGroupUserAddUserInputProps {
    groupId: number;
    userIds: number[]
}

type ApiGroupUserAddUserOutputProps = OutputBaseProps<{ added: number; }, ApiGroupUserAddUserInputProps>

export const apiGroupUserAddUser = async (data: ApiGroupUserAddUserInputProps) => {
    const res = (await axios.post<ApiGroupUserAddUserOutputProps>("/api/group/users/add", data))
        .data;
    if (res.code === 0 && res.data?.added) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};